<h1 mat-dialog-title>Guide des prérequis</h1>
<div mat-dialog-content [innerHTML]="htmlContent"></div>
<div mat-dialog-actions>
    <button class="btn btn-primary" mat-button mat-dialog-close> <div class="text-white">Fermer</div> </button>
</div>